
import React, { useState } from 'react';
import { StorageService } from '../services/db';

interface Props {
  onPostClick: (id: string) => void;
}

export const Blog: React.FC<Props> = ({ onPostClick }) => {
  const blogs = StorageService.getBlogs();
  const tags = StorageService.getTags();
  const [activeTag, setActiveTag] = useState('All');

  const filtered = activeTag === 'All' ? blogs : blogs.filter(b => b.tags.includes(activeTag));

  return (
    <div className="pt-24 pb-24 px-6 bg-stone-50">
      <div className="max-w-7xl mx-auto py-24 space-y-12">
        <h1 className="text-5xl lg:text-7xl font-light text-center uppercase tracking-tight">Magazine</h1>
        
        <div className="flex flex-wrap justify-center gap-4">
          <button onClick={() => setActiveTag('All')} className={`px-6 py-2 rounded-full text-[10px] font-bold uppercase transition-all ${activeTag === 'All' ? 'bg-stone-900 text-white' : 'bg-white text-stone-400 hover:bg-stone-100'}`}>All</button>
          {tags.map(tag => (
            <button key={tag} onClick={() => setActiveTag(tag)} className={`px-6 py-2 rounded-full text-[10px] font-bold uppercase transition-all ${activeTag === tag ? 'bg-stone-900 text-white' : 'bg-white text-stone-400 hover:bg-stone-100'}`}>{tag}</button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
          {filtered.map(post => (
            <article 
              key={post.id} 
              className="bg-white rounded-[2rem] overflow-hidden shadow-sm hover:shadow-xl transition-all flex flex-col h-full group cursor-pointer"
              onClick={() => onPostClick(post.id)}
            >
              <div className="h-64 overflow-hidden">
                <img src={post.images[0]} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" alt={post.title} />
              </div>
              <div className="p-10 space-y-6 flex-grow flex flex-col">
                <div className="flex justify-between items-center text-[10px] text-stone-400 font-bold uppercase tracking-widest">
                  <span>{post.date}</span>
                  <div className="flex gap-2">
                    {post.tags.map(t => <span key={t} className="text-stone-900">#{t}</span>)}
                  </div>
                </div>
                <h3 className="text-2xl font-bold leading-tight uppercase tracking-tight">{post.title}</h3>
                <p className="text-stone-500 line-clamp-3 text-sm">{post.excerpt}</p>
                <div className="pt-4 mt-auto">
                   <button className="text-stone-900 font-black text-[10px] uppercase tracking-widest border-b-2 border-stone-900 pb-1">Open Insights</button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};
